import { render, staticRenderFns } from "./Kkt.vue?vue&type=template&id=0f3c2496&scoped=true&"
import script from "./Kkt.vue?vue&type=script&lang=ts&"
export * from "./Kkt.vue?vue&type=script&lang=ts&"
import style0 from "./Kkt.vue?vue&type=style&index=0&id=0f3c2496&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3c2496",
  null
  
)

export default component.exports